import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { theme } from "../../../helpers/theme";
import { deleteWarehouse } from "../../../services/warehouses/warehouse-delete";
import { useMutation } from "@tanstack/react-query";
import { StyledButton } from "../../../components/Button/button";
import { toast } from "react-toastify";
import { settings } from "../../../helpers/toast.settings";
import { useFormik } from "formik";
import { getAllWarehouses } from "../../../services/warehouses/get-all";
import { GetAllWarehouses } from "../../../services/warehouses/get-all/types";
import SessionService from "../../../services/session-service";
import React, { useState } from 'react';


const OperatorWarehouseDelete = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const idAsString = String(id);

  const body1 = {
    paginacja: null,
    filtr: {
      id_magazyn: idAsString
    }
  };

  const [kodMagazynu, setKodMagazynu] = useState('KodMagazynu'); // Inicjalizacja stanu


  const GetAllWarehouses = useQuery(
     ["warehouses"],
     () => getAllWarehouses(body1),
     {
       refetchOnMount: true,
       refetchOnWindowFocus: false,
       onSuccess(data) {
        const newKodMagazynu = data.data.payload.magazyny[0].kod_magazynu;
        setKodMagazynu(newKodMagazynu); // Aktualizacja stanu
       },
     }
   );



  const deleteWarehouseMutation = useMutation(deleteWarehouse, {
    onSuccess: (res) => {
      toast.success("Usunięto magazyn pomyślnie!", {
        toastId: "WarehouseDeleteSuccesfully",
        ...settings,
      });
      navigate(`/operator/subcontractors/`);
    },
  });

  const formik = useFormik({
    initialValues: {
      //
    },
    //validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = {
        id_magazyn: idAsString
      };
      deleteWarehouseMutation.mutate(body);
    },
  });



return (
  <>
<PageContainer>
  <PageTitle>
    Czy usunąć magazyn o kodzie: <b>{kodMagazynu}</b>
  </PageTitle>
          <StyledButton
            variant="contained"
            onClick={() => {
              return navigate(`/operator/subcontractors/`);
            }}
          >
            Powrót
          </StyledButton>
          <StyledButton
            style={{ marginLeft: "10px",
            backgroundColor: 'red' }}
            variant="contained"
            onClick={() => formik.handleSubmit()
            }
          >
            Usuń
          </StyledButton>
</PageContainer>

  </>
);
};




export default OperatorWarehouseDelete;

const PageContainer = styled.div`
padding: 20px 10px;
margin-left:350px;
`;

const PageTitle = styled.h4`
width:100%;
color:${theme.colors.black_primaryText};
font-style: normal;
font-weight: ${theme.fontWeight.big};
font-size: 26px;
line-height: 40px;
margin:0px;
padding-bottom:33px;
`;


const Article = styled.div`
@media ${theme.device.Mtablet} {
    //background-color:blue;
}`;

const ArticleTitle = styled.div`
font-family: ${theme.fonts.interBold};
font-style: normal;
font-weight:  ${theme.fontWeight.big};
font-size: 16px;
line-height: 24px;
//padding: 15px 0px 0px 0px;
padding: 0px;
font-weight: 700;
margin: 0px;
@media ${theme.device.Mtablet} {
}`;